import cn from 'classnames';

import s from './ErrorSubtitle.module.css';

export interface ErrorSubTitleProps {
  text?: string;
  className?: string;
}

export function ErrorSubTitle({text, className}: ErrorSubTitleProps): JSX.Element | null {
  if (!text) return null;
  return <p className={cn(s.subTitle, className)}>{text}</p>;
}
